<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Aplicador de Descuento</div>
    <div class="box-container">
      <table>
        <tbody>
          <tr>
            <td width="115px">
              <div>Consecutivo</div>
              <input class="form-control" v-model="consecutivo" />
            </td>
            <td width="135px">
              <div>Placa</div>
              <input class="form-control" v-model="placa" />
            </td>
            <td width="135px">
              <div>Fecha inicio</div>
              <input
                id="fecha_inicio"
                v-model="fecha_inicio"
                datatype="fecha"
                readonly
                class="form-control"
              />
            </td>
            <td width="135px">
              <div>Fecha final</div>
              <input
                id="fecha_final"
                v-model="fecha_final"
                datatype="fecha"
                readonly
                class="form-control"
              />
            </td>
            <td>
              <div>.</div>
              <button
                class="btn btn-primary"
                @click="getReporteVentasPendiente"
              >
                <i class="fa-solid fa-magnifying-glass"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <div>
        <div class="row">
          <div class="col-6">
            <div>
              <table width="100%" class="table">
                <tbody>
                  <tr>
                    <td width="160px" class="border">Ticket</td>
                    <td width="80px" class="text-right border">Precio</td>
                    <td width="80px" class="text-right border">Cantidad</td>
                    <td width="80px" class="text-right border">Subtotal</td>
                    <td width="80px" class="text-right border">Descuento</td>
                    <td width="80px" class="text-right border">Total</td>
                    <td class="border">.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="area-facturas-registro">
              <table width="100%" class="table">
                <tbody>
                  <tr :key="item._id" :value="item._id" v-for="item in reporte">
                    <td width="160px" nowrap>
                      <div>{{ item.fecha }}</div>
                      <div style="margin-top: -8px">
                        {{ item.prefijo }}-{{ item.consecutivo }}
                      </div>
                      <div style="margin-top: -8px; margin-bottom: -5px">
                        <b>{{ item.placa_vin }}</b>
                      </div>
                    </td>
                    <td width="80px" class="text-right border">
                      {{ GLOBAL.FORMATO_MONEY(item.precio) }}
                    </td>
                    <td width="80px" class="text-right border">
                      {{ GLOBAL.FORMATO_NUMBER(item.cantidad) }}
                      <span class="area-facturas-unidad">
                        {{ item.unidad_codigo }}
                      </span>
                    </td>
                    <td width="80px" class="text-right border">
                      {{ GLOBAL.FORMATO_MONEY(item.venta_subtotal) }}
                    </td>
                    <td width="80px" class="text-right border">
                      {{ GLOBAL.FORMATO_MONEY(item.descuento_total) }}
                    </td>
                    <td width="80px" class="text-right border">
                      {{ GLOBAL.FORMATO_MONEY(item.venta_total) }}
                    </td>
                    <td class="text-right pad15-r border">
                      <button
                        v-if="item.movimiento_id == null"
                        @click="selectMe(item)"
                        class="btn btn-primary btn-sm"
                      >
                        <i class="fa-solid fa-plus"></i>
                      </button>

                      <button
                        v-else
                        @click="selectMe(item)"
                        class="btn btn-warning btn-sm"
                        title="Asignado a una factura"
                      >
                        <i class="fa-solid fa-file-circle-exclamation"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-6">
            <div style="border: 1px #949494 solid; padding: 10px">
              <table class="center" width="100%">
                <tbody>
                  <tr>
                    <td width="50%" class="info-box-lg-volumen text-right">
                      <div>Consecutivo:</div>
                      <div>{{ item.prefijo }}-{{ item.consecutivo }}</div>
                    </td>
                    <td class="info-box-lg-volumen text-right">
                      <div>Fecha:</div>
                      <div>{{ item.fecha }}&nbsp;</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"><br /></td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <table width="100%">
                        <tbody>
                          <tr class="bg-gray">
                            <td style="width: 110px">Placa</td>
                            <td class="text-right">Precio</td>
                            <td class="text-right">Cantidad</td>
                            <td class="text-right">Subtotal</td>
                            <td class="text-right">Descuento</td>
                            <td class="text-right">Total</td>
                          </tr>
                          <tr>
                            <td nowrap>
                              <div style="margin-top: -8px">
                                <b>{{ item.placa_vin }}</b>
                              </div>
                            </td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_MONEY(item.precio) }}
                            </td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_NUMBER(item.cantidad) }}
                              <span class="area-facturas-unidad">
                                {{ item.unidad_codigo }}
                              </span>
                            </td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_MONEY(item.venta_subtotal) }}
                            </td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_MONEY(item.descuento_total) }}
                            </td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_MONEY(item.venta_total) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                      <div>
                        <table width="100%">
                          <tbody>
                            <tr v-if="item.prefijo == null">
                              <td class="text-center">
                                <label> Descuento Valor </label>
                              </td>
                              <td class="text-center">
                                <label> Descuento Cant </label>
                              </td>
                              <td class="text-center">Nuevo Total</td>
                            </tr>
                            <tr v-else>
                              <td class="text-center">
                                <label>
                                  <input
                                    type="radio"
                                    v-model="descuentoType"
                                    value="precio"
                                    name="descuentoType"
                                  />
                                  Descuento Valor
                                </label>
                              </td>
                              <td class="text-center">
                                <label>
                                  <input
                                    type="radio"
                                    v-model="descuentoType"
                                    value="gl"
                                    name="descuentoType"
                                  />
                                  Descuento Cant
                                </label>
                              </td>
                              <td class="text-center">Nuevo Total</td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  class="form-control text-center"
                                  v-model="descuentoTotal"
                                  :readonly="!(descuentoType === 'precio')"
                                  ref="inputTotal"
                                  @input="handleChange"
                                  @focus="selectAllText('inputTotal')"
                                />
                              </td>
                              <td>
                                <input
                                  class="form-control text-center"
                                  v-model="descuentoCantidad"
                                  :readonly="!(descuentoType === 'gl')"
                                  ref="inputCantidad"
                                  @input="handleChange"
                                  @focus="selectAllText('inputCantidad')"
                                />
                              </td>
                              <td>
                                <input
                                  readonly="true"
                                  class="form-control text-center"
                                  v-model="nuevoTotal"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <div class="text-center">
                                  {{ mensaje }}
                                </div>
                                <br />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="text-center">
                                  <button
                                    class="btn btn-danger"
                                    :disabled="permitir_descuento"
                                    @click="cancelar"
                                  >
                                    Cancelar
                                  </button>
                                </div>
                              </td>
                              <td></td>
                              <td>
                                <div class="text-center">
                                  <button
                                    class="btn btn-primary"
                                    :disabled="permitir_descuento"
                                    @click="descontar"
                                  >
                                    Registrar
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div></div>
                        <div
                          v-if="
                            (descuentoTotal != 0 || descuentoCantidad != 0) &&
                            parseInt(nuevoValorTotal) < 1
                          "
                          class="descuento-alerta"
                        >
                          No deberia crear un descuento que lleve el ticket a
                          100%, ya que no se permite la facturación ${{
                            nuevoValorTotal
                          }}
                          en el SAT
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import FacturadorService from "../Facturador/FacturadorService";

export default {
  data() {
    return {
      GLOBAL,
      placa: "",
      consecutivo: "",
      fecha_inicio: "",
      fecha_fin: "",
      reporte: [],
      search: null,
      loading: false,
      facturadorService: null,
      item: [],
      nuevoValorTotal: 0,
      nuevoTotal: 0,
      descuentoCantidad: 0,
      descuentoTotal: 0,
      descuentoType: "",
      mensaje: "Para iniciar seleccione un Ticket",
      permitir_descuento: false,
    };
  },
  components: {},
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.fecha_inicio = GLOBAL.NOW().split(" ")[0] + " 00:00";
    this.fecha_final = GLOBAL.NOW().split(" ")[0] + " 23:59";
  },
  mounted() {
    this.loading = false;
    $("input[datatype='fecha']").datetimepicker();
    this.facturadorService = new FacturadorService();
    this.getReporteVentasPendiente();
  },
  methods: {
    selectAllText(refName) {
      this.$nextTick(() => {
        this.$refs[refName].select();
      });
    },

    getReporteVentasPendiente() {
      this.reporte = [];
      this.search = {};
      this.loading = true;
      this.nuevoValorTotal = 0;

      if (this.placa != "") {
        this.search["placa"] = this.placa;
      }

      if (this.consecutivo != "") {
        this.search["consecutivo"] = this.consecutivo;
      }

      this.fecha_inicio = $("#fecha_inicio").val();
      this.fecha_final = $("#fecha_final").val();

      this.facturadorService
        .getListaMovimientosParaFacturar(
          this.person,
          this.fecha_inicio,
          this.fecha_final,
          null,
          GLOBAL.TIPO_ORIGEN.COMBUSTIBLE,
          this.search
        )
        .then((data) => {
          try {
            this.reporte = data.data;
          } catch (error) {}
        });
    },

    handleChange() {
      //this.item.venta_subtotal
      const subtotal = this.item.venta_subtotal;

      if (this.descuentoType === "gl") {
        this.descuentoTotal = (
          this.descuentoCantidad * this.item.precio
        ).toFixed(2);
      } else if (this.descuentoType === "precio") {
        this.descuentoCantidad = (
          this.descuentoTotal / this.item.precio
        ).toFixed(2);
      }

      this.nuevoValorTotal = subtotal - this.descuentoTotal;
      if (this.nuevoValorTotal < 0) {
        this.permitir_descuento = true;
        this.mensaje = "El descuento supera el total de la venta";
      } else {
        this.permitir_descuento = false;
        this.mensaje =
          "El nuevo total menos el descuento será: " +
          GLOBAL.FORMATO_MONEY(this.nuevoValorTotal);
      }

      this.nuevoTotal = GLOBAL.FORMATO_MONEY(this.nuevoValorTotal);
    },

    selectMe(item) {
      this.permitir_descuento = false;
      this.item = item;
    },

    cancelar() {
      this.descuentoTotal = 0;
      this.descuentoCantidad = 0;
      this.nuevoTotal = 0;
      this.nuevoValorTotal = 0;
      this.permitir_descuento = true;
      this.mensaje = "Para iniciar seleccione un Ticket";
      this.item = [];
    },

    descontar() {
      const request = {
        uniqueId: this.item.uniqueid,
        producto_id: this.item.producto_id,
        descuento: this.descuentoTotal,
      };
      this.permitir_descuento = true;

      this.facturadorService
        .generarDescuento(this.person, request)
        .then((data) => {
          this.permitir_descuento = false;
          this.item = [];
          this.getReporteVentasPendiente();
        });
    },
  },
};
</script>
<style scoped>
.descuento-alerta {
  background-color: rgb(255, 245, 98);
  color: red;
  padding: 10px;
  margin-top: 10px;
}
</style>
